export default "__VITE_ASSET__Bq3DkiTS__"